import { render, staticRenderFns } from "./ThirdLasttable.vue?vue&type=template&id=f3351a20&"
import script from "./ThirdLasttable.vue?vue&type=script&lang=js&"
export * from "./ThirdLasttable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports